import React from 'react';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { useTimeStamp } from '../../../hooks/useTimeStamp';
import { toast } from 'react-toastify';
import axios from 'axios';
import { chatbotApi } from '../../../common/src';

const WidgetGoodSearchResultVer = (props) => {
  const { tveeImgUrl, loginId } = props;
  const list = props.childProps.payload.list;
  const param = props.childProps.payload.param;
  const preText = props.childProps.state.prevMessage;

  //console.log(props);

  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _cart = async (goodSerial, goodTitle) => {
    if (loginId === undefined || loginId === null || loginId === '') {
      toast.warn('로그인후 이용해 주세요');
    } else {
      const result = await axios.post(chatbotApi + '/api/setCart', {
        userid: loginId,
        goodSerial: goodSerial,
        goodCount: 1,
        gubun: 'C',
      });
      // //console.log(result);
      const intReturn = result.data.intReturn;
      if (intReturn === 0) {
        props.childProps.actionProvider._simpleMsg(
          '선택하신 ' + goodTitle + ' 상품을 장바구니에 담았습니다.'
        );
      }
      // alert('장바구니 담기..');
    }
    // alert('준비중입니다.');
    // return;
  };
  const _goItem = (goodSerial) => {
    window.open('https://shop.aniplustv.com/item/' + goodSerial, '', '');
  };
  const _addComma = (price) => {
    let returnString = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return returnString;
  };
  const _goShop = () => {
    window.open(
      `https://shop.aniplustv.com/search?keyword=${encodeURIComponent(param)}`,
      '',
      ''
    );
  };
  return (
    <>
      <div>
        {/* <div className="widget-containter-title" onClick={_goShop}>
          <h1>[{param}] 검색 결과 더보기</h1>
        </div> */}
        <div className="widget-container-ver">
          <div>
            <ul className="widget-content-list-ver">
              {list.map((item) => (
                <li
                  // onClick={() => _goItem(item.goodSerial)}
                  key={item.goodSerial}
                >
                  <img
                    src={tveeImgUrl + '/images/tvee-admin/shopping/' + item.img}
                    alt={item.goodTitle}
                  />
                  <div className="right">
                    <div className="title">
                      <a>{item.goodTitle}</a>
                    </div>
                    <div className="subTitle">
                      {item.SaleType === 'A' ? '예약상품' : '입고상품'}
                    </div>

                    <div className="money">
                      {_addComma(item.dcPrice)}원
                      {/* {moment(item.regDate).format('YYYY.MM.DD hh:mm')} */}
                    </div>
                    <div
                      className="cart"
                      onClick={() => _cart(item.goodSerial, item.goodTitle)}
                    >
                      장바구니
                    </div>
                    <div
                      className="page"
                      onClick={() => _goItem(item.goodSerial)}
                    >
                      상품상세
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="widget-time">{props.childProps.payload.writetime}</div>
        <div className="prev-chat-container">
          <div className="prev-contaner">
            <div onClick={_goShop} className="prev">
              <img src="/img/chatbot/icon_shop.png" />
              쇼핑몰로 이동
            </div>

            <div onClick={_goHome} className="prev">
              <img src="/img/chatbot/icon_home.png" />
              처음으로
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default shopContext(withRouter(WidgetGoodSearchResultVer));
